import { render, staticRenderFns } from "./Modeller.vue?vue&type=template&id=18c703e2"
import script from "./Modeller.vue?vue&type=script&lang=js"
export * from "./Modeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports